import React from 'react';
import { MailIcon } from 'lucide-react';
import { PRODUCT, SUPPORT_EMAIL } from '../data/woodworking';
import { PREMIUM } from '../data/premium';
export function Footer() {
  return <footer id="site-footer" className="border-t border-white/10 bg-charcoal-deep py-12 text-white" data-id="element-44" data-mp="32o4b2ak1486j">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-45" data-mp="36p6c8wxiaub5">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-46" data-mp="36ppnjusnikg7">
          <div data-id="element-47" data-mp="3uftm3nqzfu0c">
            <p className="wordmark text-[1.1rem] text-ivory sm:text-[1.25rem]" data-id="element-48" data-mp="3ud7g3sjqpmk8">
              Welding Projects That Sell<sup className="ml-0.5 font-sans text-[0.5em] font-semibold" data-id="element-49" data-mp="36d08okdmdj3">™</sup>
            </p>
            <p className="mt-2 text-[0.92rem] text-muted" data-id="element-50" data-mp="3lgomsf7ljwn4">{PRODUCT.descriptor}</p>
            <p className="label-tech mt-3 text-brass-light" data-id="element-51" data-mp="3qfjighqnxfon">{PREMIUM.edition} · {PREMIUM.access}</p>
          </div>
          <div data-id="element-52" data-mp="2a1jkhcbdo041">
            <p className="label-tech text-muted" data-id="element-53" data-mp="2ey0a6ay86mj8">Personal support</p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-1 inline-flex min-h-[44px] items-center gap-2 text-[0.92rem] text-parchment hover:text-brass-light" data-id="element-54" data-mp="2ew71kq41xs8l">
              <MailIcon className="h-4 w-4 shrink-0 text-brass-light" aria-hidden data-id="element-55" data-mp="3gbikcl8ypbyn" />
              <span className="break-all" data-id="element-56" data-mp="3v7zw3dl2cslq">{SUPPORT_EMAIL}</span>
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-1.5 border-t border-white/10 pt-6 text-[0.82rem] text-muted sm:flex-row sm:flex-wrap sm:gap-x-4" data-id="element-57" data-mp="3q7lmvs7q7cm4">
          <p data-id="element-58" data-mp="80ns6fvjmkba">© 2026 WELDING PROJECTS THAT SELL™. All rights reserved.</p>
          <p data-id="element-59" data-mp="33e536vmmkqm">Build & sell rights for the physical pieces. Digital files may not be shared or resold. No earnings are promised.</p>
        </div>
      </div>
    </footer>;
}